/* template */
<template><div :class="(externClass)" ref="__mpx_ref_collapse__" :style="[([transitionStyle,expandStyle])] | transRpxStyle" class="ts-collapse"><div class="slot-container"><slot/></div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m3239cc50"}'>
.ts-collapse
  display grid 
  transition  grid-template-rows 0.5s 0s, opacity 0.5s 0.1s
  grid-template-columns 100%
  overflow hidden
  .slot-container
    min-height 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3239cc50"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex3239cc50%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex3239cc50%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3239cc50"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index3239cc50/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
